import { motion } from "framer-motion";
import { XCircle } from "lucide-react";
import { useLang } from "@/i18n";

export default function PaymentCancel() {
  const { t } = useLang();

  return (
    <div className="min-h-screen bg-[#050505] text-white font-body flex items-center justify-center px-6">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="neon-trace bg-[#0A0A0A] p-10 w-full max-w-md text-center"
      >
        <p className="font-mono2 text-[10px] tracking-[0.3em] uppercase text-[#CCFF00] mb-8">HITMAX — VIP</p>
        <div data-testid="payment-cancel">
          <XCircle className="w-8 h-8 text-zinc-500 mx-auto mb-6" />
          <h1 className="font-display font-black tracking-tight text-2xl mb-3">{t.payment.cancelTitle}</h1>
          <p className="text-sm text-zinc-400 mb-8">{t.payment.cancelSub}</p>
          <a href="/" data-testid="payment-cancel-home-link" className="font-mono2 text-xs tracking-widest uppercase text-[#CCFF00] hover:underline">
            {t.payment.home}
          </a>
        </div>
      </motion.div>
    </div>
  );
}
